module.exports = __webpack_public_path__ + "img/index-section6-friend3.38ac8524.svg";